import { createI18n } from 'vue-i18n'
import { Locale } from '@/models/locale'
import en from '@/admin/languages/en.yaml'
import ja from '@/admin/languages/ja.yaml'
import ko from '@/admin/languages/ko.yaml'

const i18n = createI18n({
  locale: Locale.getLanguage(),
  fallbackLocale: Locale.getDefaultLanguage(),
  messages: {
    en,
    ja,
    ko,
  },
})

export default i18n
